/* Display mode (Light / Dark / System) and theme colour, from the profile menu.

   One piece of code for the portal and the Desk. The menu markup is the same in
   both (see the sidebar template and cs_desk.bundle.js), so everything here is
   delegated from the document and works whichever built the menu.

   The choice is applied at once, kept in this browser (localStorage "cs-theme"
   for light/dark, absent for System) and saved for the person on the server
   (cs_core.theme_prefs.save), so it follows them to another device. The page
   <head> already painted the saved choice before the body existed; this only
   handles changing it afterwards. */
(function () {
  "use strict";
  var root = document.documentElement;
  var prefs = null; // {mode, accent, colours, presets:[{id,label,swatch,css}]}
  var media = window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;

  function stored() {
    try { return localStorage.getItem("cs-theme"); } catch (e) { return null; }
  }
  function store(mode) {
    try {
      if (mode === "light" || mode === "dark") localStorage.setItem("cs-theme", mode);
      else localStorage.removeItem("cs-theme");
    } catch (e) {}
  }
  function currentMode() {
    if (prefs && prefs.mode) return prefs.mode;
    var s = stored();
    return s === "dark" || s === "light" ? s : "system";
  }
  function effective(mode) {
    mode = mode || currentMode();
    if (mode === "system") return media && media.matches ? "dark" : "light";
    return mode;
  }

  var painting = false; // true while we set the theme, so the Desk does not echo it back
  function paint() {
    var theme = effective();
    if (root.getAttribute("data-theme") !== theme) root.setAttribute("data-theme", theme);
    painting = true;
    // The Desk keeps its own theme too; set it through Frappe so the two agree.
    try {
      if (window.frappe && frappe.ui && typeof frappe.ui.set_theme === "function" &&
          document.body && document.body.classList.contains("cs-desk-portal")) {
        frappe.ui.set_theme(theme);
      }
    } catch (e) {}
    painting = false;
  }

  function accentCss(id) {
    if (!prefs) return "";
    for (var i = 0; i < prefs.presets.length; i++) {
      if (prefs.presets[i].id === id) return prefs.presets[i].css || "";
    }
    return "";
  }
  function paintAccent() {
    var css = accentCss(prefs ? prefs.accent : "brand");
    var el = document.getElementById("cs-accent-vars");
    if (!css) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement("style");
      el.id = "cs-accent-vars";
      document.head.appendChild(el);
    }
    el.textContent = css;
  }

  var LABELS = { system: "System", light: "Light", dark: "Dark" };
  function refreshMenu() {
    var mode = currentMode();
    document.querySelectorAll('[data-cs-value="mode"]').forEach(function (n) { n.textContent = LABELS[mode]; });
    document.querySelectorAll("[data-cs-mode]").forEach(function (b) {
      var on = b.getAttribute("data-cs-mode") === mode;
      b.setAttribute("aria-pressed", on ? "true" : "false");
      b.classList.toggle("on", on);
    });
    var accent = prefs ? prefs.accent : "brand";
    document.querySelectorAll("[data-cs-accent]").forEach(function (b) {
      var on = b.getAttribute("data-cs-accent") === accent;
      b.setAttribute("aria-pressed", on ? "true" : "false");
      b.classList.toggle("on", on);
    });
    document.querySelectorAll('[data-cs-value="accent"]').forEach(function (n) {
      var p = (prefs ? prefs.presets : []).filter(function (x) { return x.id === accent; })[0];
      n.style.background = p && p.swatch ? p.swatch : "";
      n.classList.toggle("brand", !p || !p.swatch);
    });
  }

  function save(part) {
    var args = {};
    if (part.mode) args.mode = part.mode;
    if (part.accent) args.accent = part.accent;
    try {
      if (window.frappe && frappe.call) {
        frappe.call({ method: "cs_core.theme_prefs.save", type: "POST", args: args, freeze: false, silent: true });
      }
    } catch (e) {}
  }

  function setMode(mode) {
    if (!LABELS[mode]) return;
    if (!prefs) prefs = { mode: mode, accent: "brand", colours: false, presets: [] };
    prefs.mode = mode;
    store(mode);
    paint();
    refreshMenu();
    save({ mode: mode });
  }
  function setAccent(id) {
    if (!prefs) return;
    prefs.accent = id;
    paintAccent();
    refreshMenu();
    save({ accent: id });
  }

  function init(payload) {
    if (payload) prefs = payload;
    if (!prefs) return;
    // A choice made in this browser before it was ever saved for the person is
    // kept, and saved now so it follows them.
    var s = stored();
    if ((s === "light" || s === "dark") && prefs.mode === "system" && !prefs.saved) {
      prefs.mode = s;
      save({ mode: s });
    }
    store(prefs.mode);
    paint();
    paintAccent();
    refreshMenu();
  }

  if (media && media.addEventListener) {
    media.addEventListener("change", function () { if (currentMode() === "system") paint(); });
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var head = t.closest("[data-cs-pref]");
    if (head) {
      e.preventDefault();
      e.stopPropagation();
      var key = head.getAttribute("data-cs-pref");
      var sub = document.querySelector('[data-cs-sub="' + key + '"]');
      if (sub) {
        var open = sub.hasAttribute("hidden");
        document.querySelectorAll("[data-cs-sub]").forEach(function (n) { n.setAttribute("hidden", ""); });
        document.querySelectorAll("[data-cs-pref]").forEach(function (n) { n.setAttribute("aria-expanded", "false"); });
        if (open) { sub.removeAttribute("hidden"); head.setAttribute("aria-expanded", "true"); }
      }
      return;
    }
    var m = t.closest("[data-cs-mode]");
    if (m) { e.preventDefault(); e.stopPropagation(); setMode(m.getAttribute("data-cs-mode")); return; }
    var a = t.closest("[data-cs-accent]");
    if (a) { e.preventDefault(); e.stopPropagation(); setAccent(a.getAttribute("data-cs-accent")); }
  }, true);

  window.csTheme = {
    init: init,
    setMode: setMode,
    setAccent: setAccent,
    effective: effective,
    mode: currentMode,
    isPainting: function () { return painting; },
  };

  // The portal prints the choice into the page; the Desk gets it with its boot data.
  function start() {
    var data = window.csThemePayload || (window.frappe && frappe.boot && frappe.boot.cs_theme) || null;
    if (data) init(data);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
